export const DEFAULTS = {
  NEWS: "/default_journal.png",
  PROFILE: "/default-person.png",
  LIBRARY: "/default_journal.svg",
};

export const Gender = [
  // {
  //   id: 0,
  //   name: "غير معروف",
  //   Translation: [
  //     {
  //       "name": 'Unknown',
  //       "locale": "en"
  //     }
  //   ]
  // },
  {
    id: 1,
    name: "ذكر",
    Translation: [
      {
        name: "Male",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "أنثى",
    Translation: [
      {
        name: "Female",
        locale: "en",
      },
    ],
  },
];

export const Degree = [
  {
    id: 1,
    name: "طالب",
    Translation: [
      {
        name: "Student",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "مؤهل متوسط",
    Translation: [
      {
        name: "Intermediate",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "مؤهل فوق المتوسط",
    Translation: [
      {
        name: "Above Intermediate",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "مؤهل جامعي",
    Translation: [
      {
        name: "University degree",
        locale: "en",
      },
    ],
  },
  {
    id: 5,
    name: "دبلوم الدراسات العليا",
    Translation: [
      {
        name: "Post graduate diploma",
        locale: "en",
      },
    ],
  },
  {
    id: 6,
    name: "ماجستير",
    Translation: [
      {
        name: "Master degree",
        locale: "en",
      },
    ],
  },
  {
    id: 7,
    name: "دكتوراه",
    Translation: [
      {
        name: "Ph.D degree",
        locale: "en",
      },
    ],
  },
];

export const formOfDataRequested = [
  {
    id: 1,
    name: "مايكروفيلم",
    Translation: [{ name: "Microfilm", locale: "en" }],
  },
  { id: 2, name: "ورقية", Translation: [{ name: "Paper", locale: "en" }] },
  {
    id: 3,
    name: "الكترونية",
    Translation: [{ name: "Electronic", locale: "en" }],
  },
];

export const purposeOfRequestingDataList = [
  {
    id: 1,
    name: "الدراسـات والأبحـاث",
    Translation: [
      {
        name: "Studies and Research",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "تقديمها الى جهة أخرى",
    Translation: [
      {
        name: "Submitting it to another party",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "للنشـر",
    Translation: [
      {
        name: "For publication",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "أخرى",
    Translation: [
      {
        name: "Other",
        locale: "en",
      },
    ],
  },
];

export const agencyType = [
  {
    id: 1,
    name: "وزارة",
    Translation: [
      {
        name: "Ministry",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "هيئـة",
    Translation: [
      {
        name: "Authority",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "محافظـة",
    Translation: [
      {
        name: "Governorate",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "شركـة",
    Translation: [
      {
        name: "Company",
        locale: "en",
      },
    ],
  },
];
export const workWithStatisticsOptions = [
  {
    id: 1,
    name: "قـوي",
    Translation: [
      {
        name: "Strong",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "متوسـط",
    Translation: [
      {
        name: "Average",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "ضعيـف",
    Translation: [
      {
        name: "Weak",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "لا يوجـد",
    Translation: [
      {
        name: "None",
        locale: "en",
      },
    ],
  },
];
export const usageQualityOptions = [
  {
    id: 1,
    name: "ضعيـف",
    Translation: [
      {
        name: "Weak",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "جيـد",
    Translation: [
      {
        name: "Good",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "جيـد جـدا",
    Translation: [
      {
        name: "Very Good",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "ممتـاز",
    Translation: [
      {
        name: "Excellent",
        locale: "en",
      },
    ],
  },
];

export const reportType = [
  {
    id: 1,
    name: "واردات",
    translations: [
      {
        name: "Imports",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "صادرات",
    translations: [
      {
        name: "Exports",
        locale: "en",
      },
    ],
  },
];

export const displayType = [
  {
    id: 1,
    name: "أصنـاف",
    translations: [
      {
        name: "Items",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "دول",
    translations: [
      {
        name: "Countries",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "بنود رئيسية",
    translations: [
      {
        name: "Headings",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "سنـوات",
    translations: [
      {
        name: "Years",
        locale: "en",
      },
    ],
  },
  {
    id: 5,
    name: "شهـور",
    translations: [
      {
        name: "Months",
        locale: "en",
      },
    ],
  },
];

export const countryReportDisplayType = [
  {
    id: 1,
    name: "أصنـاف",
    translations: [
      {
        name: "Items",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "بنود رئيسية",
    translations: [
      {
        name: "Headings",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "فصـول",
    translations: [
      {
        name: "Chapters",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "موانـي",
    translations: [
      {
        name: "Ports",
        locale: "en",
      },
    ],
  },
  {
    id: 5,
    name: "إجمالى الدولة",
    translations: [
      {
        name: "Total country",
        locale: "en",
      },
    ],
  },
  {
    id: 6,
    name: "سنـوات",
    translations: [
      {
        name: "Years",
        locale: "en",
      },
    ],
  },
];

export const totalDisplayType = [
  {
    id: 1,
    name: "أكبر 50 صنـف",
    translations: [
      {
        name: "Top 50 items",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "أكبر 50 دولـة",
    translations: [
      {
        name: "Top 50 countries",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "إجماليـات الفصـول",
    translations: [
      {
        name: "Total chapters",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "إجماليات البنود الرئيسية",
    translations: [
      {
        name: "Total Headings",
        locale: "en",
      },
    ],
  },
  {
    id: 5,
    name: "سلـع زراعيـة",
    translations: [
      {
        name: "Agricultural commodities",
        locale: "en",
      },
    ],
  },
  {
    id: 6,
    name: "سلـع غذائيـة",
    translations: [
      {
        name: "Food commodities",
        locale: "en",
      },
    ],
  },
];

export const itemsReportDisplayType = [
  {
    id: 1,
    name: "دول",
    translations: [
      {
        name: "Countries",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "موانـي",
    translations: [
      {
        name: "Ports",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "سنـوات",
    translations: [
      {
        name: "Years",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "شهــور",
    translations: [
      {
        name: "Months",
        locale: "en",
      },
    ],
  },
];

export const Usage_Degrees_ReportDisplayType = [
  {
    id: 1,
    name: "أصنـاف",
    translations: [
      {
        name: "Items",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "دول",
    translations: [
      {
        name: "Countries",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "بنود رئيسية",
    translations: [
      {
        name: "Headings",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "سنـوات",
    translations: [
      {
        name: "Years",
        locale: "en",
      },
    ],
  },
  {
    id: 5,
    name: "فصـول",
    translations: [
      {
        name: "Chapters",
        locale: "en",
      },
    ],
  },
];

export const Usage_Degrees = [
  {
    id: 1,
    name: "اصناف متنوعه غير مبينه- الهئية العامة للاستثمار",
    translations: [
      {
        name: "Miscellaneous items not shown - General Authority for Investment",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "سلع استهلاكيه غير معمره",
    translations: [
      {
        name: "Non-durable consumer goods",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "سلع استهلاكيه معمره",
    translations: [
      {
        name: "Durable consumer goods",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "سلع تامة الصنع",
    translations: [
      {
        name: "Finished goods",
        locale: "en",
      },
    ],
  },
  {
    id: 5,
    name: "سلع نصف مصنعه",
    translations: [
      {
        name: "Semi-manufactured goods",
        locale: "en",
      },
    ],
  },
  {
    id: 6,
    name: "سلع وسيطة",
    translations: [
      {
        name: "Intermediate goods",
        locale: "en",
      },
    ],
  },
  {
    id: 7,
    name: "سلع استثماريه",
    translations: [
      {
        name: "Investment goods",
        locale: "en",
      },
    ],
  },
  {
    id: 8,
    name: "قطن خام",
    translations: [
      {
        name: "Raw cotton",
        locale: "en",
      },
    ],
  },
  {
    id: 9,
    name: "مواد خام",
    translations: [
      {
        name: "Raw materials",
        locale: "en",
      },
    ],
  },
  {
    id: 10,
    name: "وقود",
    translations: [
      {
        name: "Fuel",
        locale: "en",
      },
    ],
  },
];

export const tariffReportDisplayType = [
  {
    id: 1,
    name: "أصنـاف",
    translations: [
      {
        name: "Items",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "دول",
    translations: [
      {
        name: "Countries",
        locale: "en",
      },
    ],
  },
  {
    id: 4,
    name: "سنـوات",
    translations: [
      {
        name: "Years",
        locale: "en",
      },
    ],
  },
  {
    id: 5,
    name: "شهـور",
    translations: [
      {
        name: "Months",
        locale: "en",
      },
    ],
  },
  {
    id: 6,
    name: "درجات الإستخدام والتصنيع",
    translations: [
      {
        name: "Degrees of use or manufacture",
        locale: "en",
      },
    ],
  },
];

export const tradeBalanceReportDisplayType = [
  {
    id: 1,
    name: "الميزان التجـاري",
    translations: [
      {
        name: "Trade Balance",
        locale: "en",
      },
    ],
  },
  {
    id: 2,
    name: "الميزان التجـاري - مناطق جغرافيـة",
    translations: [
      {
        name: "Trade balance - geographical regions",
        locale: "en",
      },
    ],
  },
  {
    id: 3,
    name: "الميزان التجـاري - تكتلات إقتصاديـة",
    translations: [
      {
        name: "Trade Balance - Economic blocs",
        locale: "en",
      },
    ],
  },
];
